var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46967 0.454045C4.76256 0.161152 5.23744 0.161152 5.53033 0.454045L9.78033 4.70404C10.0732 4.99694 10.0732 5.47181 9.78033 5.76471C9.48744 6.0576 9.01256 6.0576 8.71967 5.76471L5 2.04504L1.28033 5.76471C0.987437 6.0576 0.512563 6.0576 0.21967 5.76471C-0.0732233 5.47181 -0.0732233 4.99694 0.21967 4.70404L4.46967 0.454045Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.e659a4effa1cd8d358819317d243ece9.svg";
export { ForwardRef as ReactComponent };